import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdmissionForm from './components/AdmissionForm';
import Success from './components/Success';

function App() {
  return (
    <Routes>
      <Route path="/" element={<AdmissionForm />} />
      <Route path="/success" element={<Success />} />
    </Routes>
  );
}

export default App;
